import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/delete-account";
import { brand } from "@/config/brand";

const SITE_URL = brand.url;
const DESC =
  "Delete your Digitally Baffled account. Sign in to remove your account instantly, or request deletion by email — we confirm within 48 hours and complete within 30 days.";

export const Route = createFileRoute("/delete-account")({
  head: () => ({
    meta: [
      { title: "Delete your account | Digitally Baffled" },
      { name: "description", content: DESC },
      { name: "robots", content: "index,follow" },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "Delete your account — Digitally Baffled" },
      { property: "og:description", content: DESC },
      { property: "og:url", content: `${SITE_URL}/delete-account` },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Delete your account — Digitally Baffled" },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/delete-account` }],
  }),
  component: Page,
});
